export default {
  getRegexs: state => state.regexs,
  getRegex: state => state.regex,
}
